import React from "react";

function SvgIcMapPoi053(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 32 32" {...props}>
      <g fill="none" fillRule="evenodd">
        <path
          d="M10.558 24.564a1.5 1.5 0 11-2.121-2.12 1.5 1.5 0 012.12 2.12M26.832 9.707l-2.351 2.351a.999.999 0 01-1.414 0l-2.121-2.121a.999.999 0 010-1.414l2.35-2.353a4.994 4.994 0 00-4.825 1.29 4.997 4.997 0 00-1.293 4.823l-9.447 9.45a2.51 2.51 0 000 3.537 2.505 2.505 0 003.535 0l9.442-9.447a4.993 4.993 0 006.124-6.117"
          fill="#FFF"
        />
      </g>
    </svg>
  );
}

export default SvgIcMapPoi053;
